const Formacao = ({nomeDoCurso, local}) => {
  return (
    <div>
        <h3 id="formacao">{nomeDoCurso} - {local}</h3>
    </div>
  )
}

export default Formacao